import { YM_WINDOW_KEY } from '../const'
import { HitOptions, InitOptions } from '../types'
import { checkYmSDK } from '../utils/checkYmSDK'

export type UseYandexMetricsActionsResult = {
	init: (options?: Partial<InitOptions>) => void
	hit: (options?: Partial<HitOptions>) => void
}

export const useYandexMetricsActions = (ymID: string | number): UseYandexMetricsActionsResult => ({
	init: (options: Partial<InitOptions> = {}): void =>
		checkYmSDK() &&
		window[YM_WINDOW_KEY](ymID, `init`, {
			defer: true,
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true,
			ecommerce: `dataLayer`,
			...options
		}),

	hit: (options: Partial<HitOptions> = {}): void =>
		checkYmSDK() &&
		window[YM_WINDOW_KEY](ymID, `hit`, window.location.href, {
			title: document.title,
			...options
		})
})
